var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('tip'), _c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('my-table', {
    attrs: {
      "bordered": "",
      "fixed-header": "",
      "columns": _vm.columns,
      "data-source": _vm.dataList,
      "row-key": "rule_name"
    },
    scopedSlots: _vm._u([{
      key: "sm_code_list",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [record.sm_code_list && record.sm_code_list.length ? _c('div', [_vm._l(record.sm_code_list, function (item, index) {
          return [_c('div', {
            key: index
          }, [_vm._v(" " + _vm._s(item.sm_code) + "[" + _vm._s(item.sm_name) + "] ")])];
        })], 2) : _c('div', [_vm._v(_vm._s(_vm._f("filterEmpty")('')))])]);
      }
    }])
  })], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };